module.exports = __webpack_public_path__ + "img/61.689c208e.png";